import { Directive, HostBinding } from '@angular/core';
import { ScreenService } from 'lib/screen/index.js';

export type TooltipTheme = 'default';

@Directive({
    selector: '[libPad]',
    standalone: false
})
export class PadDirective {
	@HostBinding('style') style = 'display: block';

	@HostBinding('class')
	mobilePaddingClass = this.getPadClass();

	private readonly isMobileView: boolean;

	constructor(screenService: ScreenService) {
		this.isMobileView = screenService.currentScreen().isMobileView;
	}

	private getPadClass(): string {
		if (this.isMobileView) {
			return `pad`;
		}

		return `pad-top pad-bottom pad-left-md pad-right-md`;
	}
}
